// SkipQuickActionsModal — the 3-option chooser launched from the
// NarrowSidebar "Skip" cube (and reusable elsewhere). Navigation only —
// no business logic. Mirrors the legacy operations dashboard's
// "Skip / Bin Actions" popup:
//   - Skip Management   → navigates to /skip/dashboard (the Skip module)
//   - New Enquiry       → onNewEnquiry (opens the quick-entry enquiry modal)
//   - Update Active Job → onUpdateJob (opens the job-search modal)

import { useNavigate } from 'react-router-dom';
import { ArrowRight, Container, FilePlus2, RefreshCw } from 'lucide-react';
import { Modal } from '../../../components/ui/Modal/Modal';
import styles from './SkipQuickActionsModal.module.css';

export interface SkipQuickActionsModalProps {
  open: boolean;
  onClose: () => void;
  /** Close this chooser and open the quick-entry enquiry modal. */
  onNewEnquiry: () => void;
  /** Close this chooser and open the active-job update modal. */
  onUpdateJob: () => void;
}

export function SkipQuickActionsModal({
  open,
  onClose,
  onNewEnquiry,
  onUpdateJob,
}: SkipQuickActionsModalProps): JSX.Element {
  const navigate = useNavigate();

  return (
    <Modal open={open} onClose={onClose} title="Skip Actions" size="sm">
      <div className={styles.options}>
        <button
          type="button"
          className={styles.option}
          onClick={() => {
            navigate('/skip/dashboard');
            onClose();
          }}
        >
          <Container className={styles.icon} size={22} aria-hidden />
          <span className={styles.text}>
            <span className={styles.label}>Skip Management</span>
            <span className={styles.hint}>Open the full Skip module</span>
          </span>
          <ArrowRight className={styles.chevron} size={18} aria-hidden />
        </button>

        <button type="button" className={styles.option} onClick={onNewEnquiry}>
          <FilePlus2 className={styles.icon} size={22} aria-hidden />
          <span className={styles.text}>
            <span className={styles.label}>New Enquiry</span>
            <span className={styles.hint}>Create a new skip / bin enquiry</span>
          </span>
        </button>

        <button type="button" className={styles.option} onClick={onUpdateJob}>
          <RefreshCw className={styles.icon} size={22} aria-hidden />
          <span className={styles.text}>
            <span className={styles.label}>Update Active Job</span>
            <span className={styles.hint}>
              Raise a collection, exchange or tip &amp; return
            </span>
          </span>
        </button>
      </div>
    </Modal>
  );
}
